// technical-analytics.service.ts
import { Injectable } from '@angular/core';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root'
})
export class TechnicalAnalyticsService {
  constructor(private analyticsService: AnalyticsService) {}

  /**
   * Track app errors
   */
  trackError(errorCode: string, errorMessage: string, screen?: string): Promise<any> {
    return this.analyticsService.logEvent('app_error', {
      error_code: errorCode,
      error_message: errorMessage,
      screen: screen || 'unknown'
    });
  }

  /**
   * Track performance metrics
   */
  trackPerformance(metricName: string, metricValue: number, context?: string): Promise<any> {
    return this.analyticsService.logEvent('performance_metric', {
      metric_name: metricName,
      metric_value: metricValue,
      context: context || 'app'
    });
  }
}
